import React from 'react';
import { withIntl, IntlProps } from 'ha/i18n';
import { H2 } from 'ha/ui/Headers';
import Link from 'ha/ui/Link';
import Track from 'ha/components/track/SmartTrack';

export interface CTAProps {
  url?: string;
  description?: string;
  linkText?: string;
}

const CommunityCTACard: React.FC<CTAProps & IntlProps> = ({
  url,
  description,
  linkText,
  intl: { T, urlResolver },
}) => (
  <div className="community-card back-purple-dark flexbox flex-direction__column flex-justify-end p-x-2">
    <H2 className="color-white">
      {description ||
        T(
          'Afraid to become homeless during your internship? Find a room in your new city',
        )}
    </H2>
    <Track name="Clicked CTA in a community page" type="link">
      <Link
        to={url || urlResolver.getBaseUrl()}
        skipLangFormat
        className="btn btn-white-purple btn-block text-bold btn-lg m-y-2 box-shadow-lg"
      >
        {linkText || T('Start searching')}
      </Link>
    </Track>
  </div>
);

export default withIntl(CommunityCTACard);
